import { render } from "./DashboardPage.vue?vue&type=template&id=5711c79a&scoped=true"
import script from "./DashboardPage.vue?vue&type=script&lang=js"
export * from "./DashboardPage.vue?vue&type=script&lang=js"

import "./DashboardPage.vue?vue&type=style&index=0&id=5711c79a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5711c79a"]])

export default __exports__